import {PipeTransform, Pipe} from "@angular/core";
import {Company} from "../../shared/api/companies/api.models";

@Pipe({
    name: 'companies'
})

export class CompaniesPipe implements PipeTransform {
    transform(companies: Company[], name: string, description: string, manager: string) {
        name        = name        === 'null' ? null : name;
        description = description === 'null' ? null : description;
        manager     = manager     === 'null' ? null : manager;

        return companies.filter((company: Company) => {
            if (name && company.name.toLowerCase().indexOf(name.toLowerCase()) === -1) {
                return false;
            }

            if (description && company.description.toLowerCase().indexOf(description.toLowerCase()) === -1) {
                return false;
            }

            if (manager && company.manager.toLowerCase().indexOf(manager.toLowerCase()) === -1) {
                return false;
            }

            return true;
        });
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/settings/companies/companies.pipe.ts